import React from 'react';
import * as VoxImplant from 'voximplant-websdk';

import {
  SET_CRM_STATUS_SUCCESS,
  CHANGE_CRM_MANUAL_STATE,
  SET_MANAGER_STATUSES,
  CRM_SYNC_GENERAL_STATE,
  CRM_REQUEST_GENERAL_STATE,
  SAVE_CRITICAL_ERRORS,
  RESET_CRITICAL_ERRORS,
} from '../store/actions/general';

import { CallCenter as CallCenterIcon } from '@icons/dialer/departments';
import { Bounce as BounceIcon } from '@icons/dialer/departments';
import { Docs as DocsIcon } from '@icons/dialer/departments';
import { Hotline as HotlineIcon } from '@icons/dialer/departments';
import { NewOrders as NewOrdersIcon } from '@icons/dialer/departments';
import { Sales as SalesIcon } from '@icons/dialer/departments';
import { Visa as VisaIcon } from '@icons/dialer/departments';
import { Expert as ExpertIcon } from '@icons/dialer/departments';

export const TOGGLE_SHOWING = 'TOGGLE_SHOWING';

export const VOX_INIT = 'VOX_INIT';
export const VOX_CONNECT = 'VOX_CONNECT';
export const VOX_CONNECTED = 'VOX_CONNECTED';
export const VOX_SHOW_ERROR = 'VOX_SHOW_ERROR';
export const VOX_RESET_ERROR = 'VOX_RESET_ERROR';
export const VOX_DESTROY = 'VOX_DESTROY';

export const VOX_AUTH = 'VOX_AUTH';
export const VOX_AUTH_FAILED = 'VOX_AUTH_FAILED';
export const VOX_AUTH_SUCCESS = 'VOX_AUTH_SUCCESS';

export const VOX_CONNECTION_ESTABLISHED = 'VOX_CONNECTION_ESTABLISHED';
export const VOX_CONNECTION_CLOSED = 'VOX_CONNECTION_CLOSED';
export const VOX_CONNECTION_FAILED = 'VOX_CONNECTION_FAILED';

export const VOX_CALL_CONNECTED = 'VOX_CALL_CONNECTED';
export const VOX_CALL_DISCONNECTED = 'VOX_CALL_DISCONNECTED';
export const VOX_CALL_OUTGOING = 'VOX_CALL_OUTGOING';
export const VOX_CALL_INCOMING = 'VOX_CALL_INCOMING';

export const VOX_CALL = 'VOX_CALL';
export const VOX_ANSWER = 'VOX_ANSWER';
export const VOX_HANGUP = 'VOX_HANGUP';
export const VOX_LISTEN = 'VOX_LISTEN';
export const VOX_LISTEN_START = 'VOX_LISTEN_START';
export const VOX_LISTEN_STOP = 'VOX_LISTEN_STOP';
export const VOX_BAN = 'VOX_BAN';
export const VOX_UNBAN = 'VOX_UNBAN';
export const VOX_UNBANNING = 'VOX_UNBANNING';
export const VOX_HOLD = 'VOX_HOLD';
export const VOX_MUTE = 'VOX_MUTE';
export const VOX_VOTE_NEED = 'VOX_VOTE_NEED';
export const VOX_CONNECT_SUPERVISOR = 'VOX_CONNECT_SUPERVISOR';
export const VOX_REQUEST_HELP = 'VOX_REQUEST_HELP';
export const VOX_REQUESTING_HELP = 'VOX_REQUESTING_HELP';
export const VOX_CANCEL_HELP_REQUEST = 'VOX_CANCEL_HELP_REQUEST';
export const VOX_SEND_TONE = 'VOX_SEND_TONE';
export const VOX_DEANINOMIZE = 'VOX_DEANINOMIZE';
export const VOX_TRANSFER = 'VOX_TRANSFER';
export const VOX_SUPERVISING = 'VOX_SUPERVISING';
export const VOX_WITHDRAW = 'VOX_WITHDRAW';
export const VOX_LOG_REACTION = 'VOX_LOG_REACTION';

export const SET_VOX_STATUS = 'SET_VOX_STATUS';
export const VOX_SYNC_STATUS = 'VOX_SYNC_STATUS';
export const VOX_SET_PBX_ID = 'VOX_SET_PBX_ID';
export const VOX_SET_CALL_ID = 'VOX_SET_CALL_ID';
export const VOX_SYNC_SOCKET_STATE = 'VOX_SYNC_SOCKET_STATE';

export const VOX_CALL_TRANSFERING = 'VOX_CALL_TRANSFERING';

export const TOGGLE_OPERATORS = 'TOGGLE_OPERATORS';
export const TOGGLE_DEPARTMENTS = 'TOGGLE_DEPARTMENTS';
export const TOGGLE_RECENT_CALLS = 'TOGGLE_RECENT_CALLS';

export const FETCH_OPERATORS = 'FETCH_OPERATORS';
export const FETCH_DEPARTMENTS = 'FETCH_DEPARTMENTS';
export const FETCH_RECENT_CALLS = 'FETCH_RECENT_CALLS';
export const SET_CLIENT_INFO = 'SET_CLIENT_INFO';

export const SET_OPERATORS = 'SET_OPERATORS';
export const SET_DEPARTMENTS = 'SET_DEPARTMENTS';
export const SET_TRANSFER_FAIL = 'SET_TRANSFER_FAIL';
export const SET_DEANINOMIZE = 'SET_DEANINOMIZE';
export const SET_RECENT_CALLS = 'SET_RECENT_CALLS';
export const CHANGE_MANUAL_VOX_STATE = 'CHANGE_MANUAL_VOX_STATE';

export const VOX_REQUEST_LAST_STATE = 'VOX_REQUEST_LAST_STATE';
export const VOX_SYNC_LAST_STATE = 'VOX_SYNC_LAST_STATE';

export const ERROR_MIC = 'Подключите микрофон.';
export const ERROR_USER_NO_ACCESS = 'Пользователь не подключен к телефонии.';

export const VOX_EVENTS_CHANNEL = 'VOX_EVENTS_CHANNEL';
export const VOX_INCIDENT = 'VOX_INCIDENT';

export const VOX_LOCALSTORAGE_LAST_STATE = 'vox_last_status';
export const VOX_LOCALSTORAGE_LAST_STATE_CHANGED_AT = 'vox_status_changed_at';

export const VOX_CRITICAL_ACTIONS = [ERROR_MIC];

export const syncVoxEvents = action => {
  const isVoxEvent = action.type.startsWith('VOX_');

  const isAdditionalIncluded = [
    CHANGE_MANUAL_VOX_STATE,
    CHANGE_CRM_MANUAL_STATE,
    SET_CRM_STATUS_SUCCESS,
    SET_CLIENT_INFO,
    SET_MANAGER_STATUSES,
    CRM_REQUEST_GENERAL_STATE,
    CRM_SYNC_GENERAL_STATE,
    SAVE_CRITICAL_ERRORS,
    RESET_CRITICAL_ERRORS,
  ].includes(action.type);

  const isAdditionalExcluded = ![
    VOX_INIT,
    VOX_AUTH,
    VOX_CONNECT,
    VOX_DESTROY,
    VOX_LISTEN,
    VOX_LISTEN_START,
    VOX_REQUEST_HELP,
    VOX_AUTH_SUCCESS,
    VOX_AUTH_FAILED,
  ].includes(action.type);

  return (isVoxEvent || isAdditionalIncluded) && isAdditionalExcluded;
};

export const mapVoxStatuses = {
  afterService: VoxImplant.OperatorACDStatuses.AfterService,
  dnd: VoxImplant.OperatorACDStatuses.DND,
  inService: VoxImplant.OperatorACDStatuses.InService,
  offline: VoxImplant.OperatorACDStatuses.Offline,
  online: VoxImplant.OperatorACDStatuses.Online,
  ready: VoxImplant.OperatorACDStatuses.Ready,
};

export const VOX_INCIDENT_STATUSES = {
  GOOD: 'Good',
  RESOLVED: 'Resolved',
  INVESTIGATING: 'Investigating',
};

export const departments = {
  CallCenterQueue: {
    svg: <CallCenterIcon width={48} />,
  },
  SalesQueue: {
    svg: <SalesIcon width={48} />,
  },
  EmergencyQueue: {
    svg: <HotlineIcon width={48} />,
  },
  BookingQueue: {
    isReserve: true,
    svg: <NewOrdersIcon width={48} />,
  },
  ExpertQueue: {
    svg: <ExpertIcon width={48} />,
  },
  VisaQueue: {
    isReserve: true,
    svg: <VisaIcon width={48} />,
  },
  DocumentsQueue: {
    isReserve: true,
    svg: <DocsIcon width={48} />,
  },
  RecoveryQueue: {
    isReserve: true,
    svg: <BounceIcon width={48} />,
  },
};

export const VOX_STATES = {
  AFTER_SERVICE: 'afterService',
  BANNED: 'banned',
  DND: 'dnd',
  IN_SERVICE: 'inService',
  INCOMING: 'incoming',
  OFFLINE: 'offline',
  ONLINE: 'online',
  OUTGOING: 'outgoing',
  READY: 'ready',
};

export const VOX_CHOOSABLE_STATES = [
  VOX_STATES.READY,
  VOX_STATES.ONLINE,
  VOX_STATES.DND,
  VOX_STATES.OFFLINE,
];

export const VOX_STATES_LABELS = {
  [VOX_STATES.AFTER_SERVICE]: 'Пауза после звонка',
  [VOX_STATES.DND]: 'Недоступен для звонка/перевода',
  [VOX_STATES.IN_SERVICE]: 'В разговоре',
  [VOX_STATES.OFFLINE]: 'Вне смены',
  [VOX_STATES.ONLINE]: 'Доступен для перевода (II очередь)',
  [VOX_STATES.READY]: 'Доступен для звонка/перевода',
};
